import { render, staticRenderFns } from "./ContentContactList.vue?vue&type=template&id=16d5b476&scoped=true"
import script from "./ContentContactList.vue?vue&type=script&lang=js"
export * from "./ContentContactList.vue?vue&type=script&lang=js"
import style0 from "./ContentContactList.vue?vue&type=style&index=0&id=16d5b476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d5b476",
  null
  
)

export default component.exports